import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';
import Icon from '@ant-design/icons';
import React from 'react';

const DensityCompactIconSvg = () =>
	<svg
		fill='currentColor'
		height='24'
		viewBox='0 0 24 24'
		width='24'
		xmlns='http://www.w3.org/2000/svg'>
		<path d='M4 5V7H21V5M4 11H21V9H4M4 19H21V17H4M4 15H21V13H4V15Z' />
	</svg>;
export const DensityCompactIcon: React.FC<Partial<CustomIconComponentProps>> = (props) =>
	<Icon
		component={ DensityCompactIconSvg }
		style={ {
			marginLeft: '-1px',
			marginTop: '-1px'
		} }
		{ ...props } />;

